export default "__VITE_ASSET__BJ_faQ6e__"